import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { ChevronLeft, ChevronRight, Calendar } from "lucide-react";
import { PlannerPeriod } from "./plannerUtils";

interface PlannerHeaderProps {
  period: PlannerPeriod;
  onPeriodChange: (period: PlannerPeriod) => void;
  periodLabel: string;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
}

export function PlannerHeader({
  period,
  onPeriodChange,
  periodLabel,
  onPrevious,
  onNext,
  onToday,
}: PlannerHeaderProps) {
  return (
    <div className="flex items-center justify-between gap-4 p-3 border-b bg-card">
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onToday}
          className="gap-1.5"
        >
          <Calendar className="h-4 w-4" />
          Today
        </Button>

        <div className="flex items-center">
          <Button
            variant="ghost"
            size="icon"
            onClick={onPrevious}
            className="h-8 w-8"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onNext}
            className="h-8 w-8"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>

        <span className="text-sm font-medium min-w-[180px]">
          {periodLabel}
        </span>
      </div>

      <Select value={period} onValueChange={(v) => onPeriodChange(v as PlannerPeriod)}>
        <SelectTrigger className="w-[130px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="week">Week</SelectItem>
          <SelectItem value="2-weeks">2 Weeks</SelectItem>
          <SelectItem value="month">Month</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
